module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABa0lEQVRIx2NoMvVgz0tjKMygProkYLJG0VY+OYEmRgPRcVFzt8BwmhgNQRWWXqz56TQxGoiWqdpLpiXRxGggOixuYRsaSWWjb5lpQ9mCpvtSy1ccOrDiyCGyEdTofXz6y0TUP63lPcZvOIdHfQ0vyI65POoiTKwMZAOgEdv5dCWZ2MIUeZdMYnDn5Z/IrQL3B9BKUxZeMo2+rqFXH8FemshbXWSjoSayb43fu0PcrzrFLosbQUy/IGCcwiHJSJ6rL0sY5YSZW1hYpKSklJeXbyzwQI4Aiowu4JQJsDCY2Jc3fXLRlvUdCUam1AkQoP4+buW3M4Te9IvcNNL+vInnWLj0EX5D6kTjJUGTez6qEGdeFja+56kGFLlTnP383vLnD1aQjbBkmavyBh+W8P95yEAhQjf6to3m9xNslJuLbvSTTLnfdxipYi7C6CvShu9mC1LLUITRwKLj2yEO6poLMvpRgsLvW0xUNxeIAG5DmnAPjH4zAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mz.png
// module id = 894
// module chunks = 0